/* /document-translate — блок «Как выглядит переведённый документ».
 *
 * Сервер уже нарисовал первую пару (документ по умолчанию, язык страницы), и
 * блок читается без этого файла. Здесь только выбор: документ, язык перевода,
 * «оригинал / перевод» на узком экране и «Открыть крупнее» через общую дверь
 * __wholeScreen (настоящий полный экран, на iPhone — наложение).
 *
 * Картинку меняем только после того, как новая расшифрована: иначе при смене
 * языка лист на миг пустеет и страница под ним прыгает на высоту листа.
 */
(function () {
    'use strict';
    var root = document.getElementById('dtEx');
    if (!root) return;

    var view = document.getElementById('dtExView');
    var pages = root.querySelector('.dt-ex-pages');
    var imgOrig = document.getElementById('dtExOrig');
    var imgTr = document.getElementById('dtExTr');
    var lnTr = document.getElementById('dtExLn');
    var sel = document.getElementById('dtExLang');
    var zoom = document.getElementById('dtExZoom');
    var docBtns = Array.prototype.slice.call(root.querySelectorAll('.dt-ex-doc'));
    var flipBtns = Array.prototype.slice.call(root.querySelectorAll('.dt-ex-flip .tc-seg-b'));
    if (!view || !pages || !imgOrig || !imgTr || !sel) return;

    var base = root.getAttribute('data-base') || '';
    var ver = root.getAttribute('data-v') || '1';
    var source = root.getAttribute('data-source') || 'en';

    function current() {
        for (var i = 0; i < docBtns.length; i++) if (docBtns[i].getAttribute('aria-pressed') === 'true') return docBtns[i];
        return docBtns[0];
    }
    function url(doc, lang) { return base + doc + '-' + lang + '.webp?v=' + ver; }
    function langName(code) {
        for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === code) return sel.options[i].textContent;
        return code;
    }
    function fill(tpl, vars) {
        return String(tpl || '').replace(/:(doc|lang)\b/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
    }

    // Одна смена на картинку: если человек щёлкнул дальше, пока грузилась
    // прошлая, старая уже не встанет поверх новой.
    var ticket = { o: 0, t: 0 };
    function swap(img, slot, src, w, h, alt) {
        var n = ++ticket[slot];
        if (img.getAttribute('src') === src) { img.alt = alt; return; }
        img.classList.add('dt-ex-wait');
        var pre = new Image();
        pre.decoding = 'async';
        var done = function () {
            if (n !== ticket[slot]) return;
            img.width = w; img.height = h;
            img.src = src;
            img.alt = alt;
            img.classList.remove('dt-ex-wait');
        };
        pre.onerror = done;          // нет файла — пусть браузер покажет обычную пустую картинку, а не вечную серость
        pre.src = src;
        if (pre.decode) pre.decode().then(done, done); else pre.onload = done;
    }

    function render() {
        var b = current();
        if (!b) return;
        var doc = b.getAttribute('data-doc');
        var w = +b.getAttribute('data-w') || 880, h = +b.getAttribute('data-h') || 1245;
        var name = b.getAttribute('data-name') || '';
        var lang = sel.value;
        var lname = langName(lang);
        swap(imgOrig, 'o', url(doc, source), w, h, fill(imgOrig.getAttribute('data-alt'), { doc: name }));
        swap(imgTr, 't', url(doc, lang), w, h, fill(imgTr.getAttribute('data-alt'), { doc: name, lang: lname }));
        imgTr.setAttribute('lang', lang);
        if (lnTr) { lnTr.textContent = lname; lnTr.setAttribute('lang', lang); }
    }

    // Телеметрия: что смотрят. Одно событие на пару «действие + значение» за
    // загрузку страницы — перебор языков не забивает очередь событий.
    var sent = {};
    function note(action, value) {
        var k = action + ':' + value;
        if (sent[k]) return;
        sent[k] = 1;
        try { if (window.__ae) window.__ae('feature_use', { slug: 'document-translate', action: action, v: String(value) }); } catch (_) {}
    }

    docBtns.forEach(function (b) {
        b.addEventListener('click', function () {
            if (b.getAttribute('aria-pressed') === 'true') return;
            docBtns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
            render();
            note('examples_doc', b.getAttribute('data-doc'));
        });
    });
    sel.addEventListener('change', function () { render(); note('examples_lang', sel.value); });

    function show(which) {
        pages.setAttribute('data-show', which);
        flipBtns.forEach(function (o) {
            var on = o.getAttribute('data-show') === which;
            o.classList.toggle('on', on);
            o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
    }
    flipBtns.forEach(function (b) {
        b.addEventListener('click', function () {
            show(b.getAttribute('data-show'));
            note('examples_flip', b.getAttribute('data-show'));
        });
    });

    // «Открыть крупнее» — только когда дверь есть (timbrica-core.js); без неё
    // кнопка осталась бы мёртвой, поэтому она и скрыта в разметке.
    if (zoom && typeof window.__wholeScreen === 'function') {
        var label = zoom.querySelector('.dt-ex-zl');
        var whole = window.__wholeScreen(view, {
            key: 'dt-examples',
            onChange: function (on) {
                if (label) label.textContent = zoom.getAttribute(on ? 'data-close' : 'data-open');
                zoom.setAttribute('aria-pressed', on ? 'true' : 'false');
            }
        });
        zoom.hidden = false;
        zoom.setAttribute('aria-pressed', 'false');
        zoom.addEventListener('click', function () {
            var was = whole.active();
            whole.toggle();
            if (!was) note('examples_zoom', 'open');
        });
        [imgOrig, imgTr].forEach(function (img) {
            img.addEventListener('click', function () {
                if (whole.active()) return;
                whole.enter();
                note('examples_zoom', 'page');
            });
        });
    }
})();
